import { render, staticRenderFns } from "./tab-btn.vue?vue&type=template&id=24bf4fea&scoped=true&"
import script from "./tab-btn.vue?vue&type=script&lang=js&"
export * from "./tab-btn.vue?vue&type=script&lang=js&"
import style0 from "./tab-btn.vue?vue&type=style&index=0&id=24bf4fea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bf4fea",
  null
  
)

export default component.exports